<template>
  <div>
    <b-row>
      <!-- Real-time Monitoring -->
      <b-col md="6">
        <b-card>
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="font-weight-bolder mb-0">Real-time Monitoring</h5>
            <b-button
              variant="link"
              class="p-0 text-primary font-weight-bolder"
              style="font-size: 13px"
              to="/settings/system-configuration"
            >
              <feather-icon icon="ExternalLinkIcon" size="14" />
              System Config - Status screen
            </b-button>
          </div>
          <b-card
            border-variant="secondary"
            body-class="p-0"
            class="w-100"
            style="padding: 8px"
          >
            Intrusion Detection
            <span class="text-success">●</span>
          </b-card>
          <b-card
            border-variant="secondary"
            body-class="p-0"
            class="w-100"
            style="padding: 8px"
          >
            Firewall Status
            <span class="text-success">●</span>
          </b-card>
          <b-card
            border-variant="secondary"
            body-class="p-0"
            class="w-100"
            style="padding: 8px"
          >
            DDoS Protection
            <span class="text-success">●</span>
          </b-card>
          <b-card
            border-variant="secondary"
            body-class="p-0"
            class="w-100 mb-0"
            style="padding: 8px"
          >
            SSL Certificate
            <span class="text-warning">●</span>
          </b-card>
        </b-card>
      </b-col>

      <!-- Recent Security Events -->
      <b-col md="6">
        <b-card>
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="font-weight-bolder mb-0">Recent Security Events</h5>
            <b-button
              variant="link"
              class="p-0 text-primary font-weight-bolder"
              style="font-size: 13px"
              to="/settings/security-and-compliance"
            >
              <feather-icon icon="ShieldIcon" size="14" />
              Security screen
            </b-button>
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <b-card
              border-variant="secondary"
              body-class="p-0"
              class="w-100"
              style="padding: 8px"
            >
              <div class="d-flex align-items-center" style="gap: 12px">
                <feather-icon icon="AlertTriangleIcon" class="text-danger" />
                <div>
                  <p class="font-weight-bolder mb-0">Failed Login Attempts</p>
                  <span class="small text-muted">15 minutes ago</span>
                </div>
              </div>
            </b-card>
          </div>

          <div class="d-flex justify-content-between align-items-center">
            <b-card
              border-variant="secondary"
              body-class="p-0"
              class="w-100"
              style="padding: 8px"
            >
              <div class="d-flex align-items-center" style="gap: 12px">
                <feather-icon icon="CheckCircleIcon" class="text-success" />
                <div>
                  <p class="font-weight-bolder mb-0">Security Scan Completed</p>
                  <span class="small text-muted">1 hour ago</span>
                </div>
              </div>
            </b-card>
          </div>

          <div class="d-flex justify-content-between align-items-center">
            <b-card
              border-variant="secondary"
              body-class="p-0"
              class="w-100 mb-0"
              style="padding: 8px"
            >
              <div class="d-flex align-items-center" style="gap: 12px">
                <feather-icon icon="EyeIcon" class="text-primary" />
                <div>
                  <p class="font-weight-bolder mb-0">Suspicious API Activity</p>
                  <span class="small text-muted">3 hours ago</span>
                </div>
              </div>
            </b-card>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { BCard, BButton, BTable, BBadge, BRow, BCol } from "bootstrap-vue";
export default {
  components: {
    BCard,
    BButton,
    BTable,
    BBadge,
    BRow,
    BCol,
  },
};
</script>
